import * as Sentry from '@sentry/react'

import { SENTRY_SEVERITY } from '@/shared/sentry'
import { cmdTypeLabel, WATCH_CMD_TYPES } from '@/shared/sentry/api'

type FlowPhase = 'request' | 'response'

type FlowBreadcrumbData = {
  cmdType?: string
  ResultCd?: string
  ResultMsg?: string
}

export function addApiBreadcrumb(phase: FlowPhase, data: FlowBreadcrumbData) {
  const cmdType = data?.cmdType
  if (!cmdType || !WATCH_CMD_TYPES.has(cmdType)) return

  Sentry.addBreadcrumb({
    category: 'api',
    message: `${cmdTypeLabel(cmdType)}[${phase}]`,
    level: phase === 'response' ? SENTRY_SEVERITY.Warning : SENTRY_SEVERITY.Info,
    data: {
      cmdType: cmdTypeLabel(cmdType),
      path: window.location.pathname,
      phase,
      errCode: data.ResultCd,
      errMsg: data.ResultMsg,
    },
  })
}
